/*
 * Copyright (c) 2019, F5 Networks, Inc. All rights reserved.
 *
 * No part of this software may be reproduced or transmitted in any
 * form or by any means, electronic or mechanical, for any purpose,
 * without express written permission of F5 Networks, Inc.
 */
import { IResourceProps, IResourceId } from 'apmui/resource/ResourceLoader';
import RESOURCE from 'apmui/resource/ResourceType';
import WebtopResourceModel from 'apmui/resource/WebtopResourceModel';

class WebtopFolderModel extends WebtopResourceModel {
    static readonly propNames = WebtopResourceModel.propNames;

    type: RESOURCE.WEBTOP_FOLDER = RESOURCE.WEBTOP_FOLDER;
    assignedResources: IResourceId[];
    folder?: string;

    constructor(id: string, resource: IResourceProps) {
        super(id, resource);

        this.assignedResources = resource.assignedResources || [];
        this.folder = resource.props.folder;

        this.undefinedIconToDefault();
    }

    getPropNames(): string[] {
        return WebtopFolderModel.propNames;
    }
}

export default WebtopFolderModel;
